import { createShapeFromSvgString } from "./createShapeFromSvgString";
import { createSvgFromSvgPath } from "./createSvgFromSvgPath";
export function createShapeFromSvgPath(path, opts = {}) {
    const fluxSvgMarkup = createSvgFromSvgPath(path);
    return createShapeFromSvgString(fluxSvgMarkup, opts);
}
//# sourceMappingURL=createShapeFromSvgPath.js.map